(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.SolutionBuilderAgent:MxImagePicker
	 * @module mx.SolutionBuilderAgent
	 * @restrict 'E'
	 * @description
	 * The mx-image-picker control is used to create a picker where the user can
	 * select icon, upload file as attachment or pick image from server folder.
	 *
	 * The example below demonstrates some of the attributes you may use with the Picker control:
	 * @param {string} label@ - Defines control label displayed on the form.
	 * @param {boolean} ng-required= - The required property sets or returns whether a mxPicker must be filled out before submitting a form.
	 * @param {boolean} disabled= - The disabled property sets or returns whether a mxPicker should be disabled, or not.
	 * @param {boolean} readOnly= - The readOnly property sets or returns whether the contents of a mxPicker should be read-only.
	 * @param {object} value - binds element to the object in the model.
	 * @param {expression} onChange& - on change callback
	 * @usage <mx-icon-picker ng-model="vm.pickerValue" ng-required="true" data-label="Classic, predfined items" > </mx-icon-picker>
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxImagePicker', {
		bindings: {
			baseFolder: '@?',
			disabled: '<?',
			displayMode: '@',
			height: '@?',
			iconSize: '@?',
			label: '@',
			maxHeight: '@?',
			maxWidth: '@?',
			minHeight: '@?',
			minWidth: '@?',
			modeAttach: '@',
			modeIcon: '@',
			modeImage: '@',
			serverBasePath: '@',
			onChange: '&',
			readOnly: '<?',
			required: '<?ngRequired',
			value: '=?ngModel',
			width: '@?',
		},
		controller: MxImagePicker,
		controllerAs: 'vm',
		require: {
			form: '^?mxForm',
			parentViewController: '?^^mxView',
		},
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-image-picker/mx-image-picker.html',
	});

	MxImagePicker.$inject = ['$scope', 'mx.SolutionBuilderAgent.DialogOpenerService', 'mx.shell.Config', 'mx.internationalization'];

	function MxImagePicker($scope, dialogOpener, mxConfig, i18n) {
		var vm = this;
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-image-picker');

		vm.onBrowseLookup = onBrowseLookup;
		vm.onClear = onClear;
		vm.browseLookup = browseLookup;

		vm.$onInit = function () {
			vm.basePath = mxConfig.get();

			// Height: '20rem',
			vm.viewStyle = {
				// FontSize: vm.iconSize || '5rem',
				height: vm.height,
				maxHeight: vm.maxHeight,
				maxWidth: vm.maxWidth,
				minHeight: vm.minHeight || '10rem',
				minWidth: vm.minWidth || '5rem',
				width: vm.width,
			};
			vm.iconValue = vm.value && vm.value.indexOf('/') === -1 && vm.value.split('.').length > 1;
		};

		vm.$postLink = function () {};

		$scope.$watch('vm.value', function () {
			vm.iconValue = vm.value && vm.value.indexOf('/') === -1 && vm.value.split('.').length > 1;
		});

		return vm;

		function onBrowseLookup(event) {
			if (event && event.stopPropagation) {
				event.stopPropagation();
			}

			if (vm.browseLookup && !(vm.disabled || vm.readOnly)) {
				browseLookup(vm.value)
					.then(function (res) {
						vm.value = res.selectedImage;
					})
					.catch(mx.logCatch);
			}
		}

		function onClear(event) {
			if (event && event.stopPropagation) {
				event.stopPropagation();
			}
			vm.value = '';
		}

		function browseLookup(selectedImage) {
			let objectView = vm.parentViewController?.mxView;
			while (!objectView?.context?._id && objectView?.parentView) {
				objectView = objectView.parentView;
			}
			return dialogOpener.selectImage(
				{
					baseFolder: vm.baseFolder,
					modeAttach: vm.modeAttach === 'true',
					modeIcon: vm.modeIcon === 'true',
					modeImage: vm.modeImage === 'true',
					serverBasePath: vm.serverBasePath,
					selectedImage: selectedImage,
				},
				vm.form?.objectId || objectView?.context?._id,
				vm.form?.entityName || objectView?.context?._type,
				vm.parentViewController && vm.parentViewController.mxView
			);
		}
	}
})();
